import { Indicator } from 'utils/models';

export const REPORT_STATUS = {
  requested: 'requested',
  rendered: 'rendered',
  COMPLETE: 'COMPLETE',
};

export type ReportContentValues = {
  [key in Indicator]: number;
};

export interface GroupReportConfiguration {
  id: string;
  creationTimestamp: number;
  prescriptionTriggers: {
    '7PeriodDaysPassed': boolean;
    '30PeriodDaysPassed': boolean;
    prescriptionEnded: boolean;
  };
  reportContent: ReportContentValues;
  reportsTotal: number;
}

export interface CreateReportValues {
  userId?: string;
  groupId?: string;
  startDate: Date;
  endDate: Date;
  reportContent: ReportContentValues;
  reportsTotal: number;
}

export interface ReportData {
  measurementId?: string;
  language?: string;
  forMeasurementUpdatedTimestamp: number;
  readFileToken?: string;
}
